/**
 * Floating Banner
 */
export function floating_banner() {
	const banner = document.getElementById('gtm-custom-banner');

	if (banner) {

		const closeButton = banner.querySelector('.c-floating-banner__close');

		if (closeButton) {
			closeButton.addEventListener('click', () => {
				banner.classList.remove('is-show');
			});
		}
	}
}